import { render, staticRenderFns } from "./cotizaciones_admin.vue?vue&type=template&id=270430df&scoped=true&"
import script from "./cotizaciones_admin.vue?vue&type=script&lang=js&"
export * from "./cotizaciones_admin.vue?vue&type=script&lang=js&"
import style0 from "./cotizaciones_admin.vue?vue&type=style&index=0&id=270430df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270430df",
  null
  
)

export default component.exports